
const env = {
    BACKEND_API_URL: process.env.REACT_APP_BACKEND_API_BASE_URL,
    ELASTIC_API_URL: process.env.REACT_APP_ELASTIC_API_BASE_URL,
    RECAPTCHA_KEY: process.env.REACT_APP_RECAPTCHA_KEY,
};

export default env;